import r from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import p from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import m from "./index.es102.js";
const j = ({
  pages: e,
  title: o,
  ingress: l,
  keyContext: i,
  subjectSlug: n
}) => /* @__PURE__ */ r.createElement("div", { className: "bl-container bl-container--small bl-m-b-7" }, /* @__PURE__ */ r.createElement("h2", { className: "bl-size-2 bl-p-b-3" }, o), !!l && /* @__PURE__ */ r.createElement(
  p,
  {
    keyContext: `${i}-ingress`,
    content: l,
    className: "bl-p-b-3"
  }
), /* @__PURE__ */ r.createElement("ul", { className: "bl-link-list bl-link-list--pointer bl-link-list--full-width" }, !!e && e.map(
  (t) => t && /* @__PURE__ */ r.createElement("li", { key: `${i}-page-${t.slug}` }, !t.externalUrl && /* @__PURE__ */ r.createElement(
    m,
    {
      href: `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/${n}/${t.slug}`
    },
    t.linkText || t.displayTitle || t.title
  ), !!t.externalUrl && /* @__PURE__ */ r.createElement(m, { href: t.externalUrl }, t.linkText || t.displayTitle || t.title))
)));
export {
  j as default
};
//# sourceMappingURL=index.es51.js.map
